/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

/**
 * File size validation rule.
 *
 * Creates a custom file size validation rule.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const FileSizeValidator: object = {
    /**
     * Validate the file size.
     *
     * @param {File[] | undefined} value
     * @param {number} size
     *
     * @returns {boolean}
     */
    validate(value: File|File[]|undefined|null, {size}: {size: number}): boolean {
        if (undefined === value || null === value) {
            return false;
        }

        const files: File[] = (value instanceof File) ? [value] : value;

        for (const file of files) {
            if (file.size > size) {
                return false;
            }
        }

        return true;
    },
};
